import React from 'react';
import { graphql } from 'gatsby';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import MobileAppDevelopmentPage from '../../components/MobileAppDevelopmentPage';
import { PageWrapper } from '../../components/homePage/styled';
import SEO from '../../components/SEO';

const MobileAppDevelopment = ({
  data: {
    site: {
      siteMetadata: { titleTemplate, siteUrl },
    },
    pageInfo: {
      frontmatter: { seoTitle, description, keywords },
    },
  },
}) => {
  return (
    <PageWrapper>
      <SEO
        titleTemplate={titleTemplate}
        title={seoTitle}
        keywords={keywords}
        url={siteUrl}
        description={description}
      />
      <Header />
      <MobileAppDevelopmentPage />
      <Footer />
    </PageWrapper>
  );
};

export const query = graphql`
  {
    site {
      siteMetadata {
        titleTemplate
        siteUrl
      }
    }
    pageInfo: markdownRemark(frontmatter: { name: { eq: "services/mobile-app-development" } }) {
      frontmatter {
        title
        longTitle
        seoTitle
        description
        keywords
      }
    }
  }
`;

export default MobileAppDevelopment;
